import { useEffect } from 'react';

import { setReactQueryErrorNotifier } from '@api/query-client';
import { isUnauthorizedResponseError } from '@api/response-errors.ts';
import { useAppNotify } from '@assets/helpers/hooks';
import { getErrorMessage } from '@assets/helpers/utils/get-error-message.ts';

/** Connects React Query cache errors to the application notification system. */
export const QueryErrorNotifier = () => {
  const { notifyError } = useAppNotify();

  useEffect(() => {
    setReactQueryErrorNotifier((error) => {
      if (isUnauthorizedResponseError(error)) {
        return;
      }

      notifyError(getErrorMessage(error));
    });

    return () => {
      setReactQueryErrorNotifier();
    };
  }, [notifyError]);

  return null;
};
